<template>
  <div class="the-navbar__user-meta flex items-center">
    
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="flex items-center">
        <div class="text-left leading-tight hidden sm:block ml-3" style="font-family: cairo">
          
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z"/>
          </svg>


          <svg style="transform: translate(-5px, 0px);" xmlns="http://www.w3.org/2000/svg" width="8" height="4.574" viewBox="0 0 8 4.574">
            <path id="Icon_ionic-ios-arrow-forward" data-name="Icon ionic-ios-arrow-forward" d="M14.442,10.195,11.414,7.17a.569.569,0,0,1,0-.807.577.577,0,0,1,.81,0l3.43,3.427a.571.571,0,0,1,.017.788L12.227,14.03a.572.572,0,1,1-.81-.807Z" transform="translate(14.196 -11.246) rotate(90)" fill="#6e6b7b"/>
          </svg>
        </div>
      </div>

        <div>
          <vs-dropdown-menu class="vx-navbar-dropdown">
            <div style="min-width: 25rem">
              <accounts  :is-current-user="isCurrentUser"/>
            </div>
          </vs-dropdown-menu>
        </div>
      </vs-dropdown>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import aclAccess from "@/mixins/hasAccess"
  import Accounts from '../../../../views/pages/login/Accounts.vue';
  
  export default {
    mixins: [aclAccess],
    data() {
      return {
        profiles: JSON.parse(localStorage.getItem('profiles')) || [],
        currentUserId: null,
      }
    },
    components: {
      Accounts,
    },
    computed: {
      ...mapGetters('userData', ['client', 'user'])
    },
    watch: {
      user(newUser) {
        this.currentUserId = newUser.id;
      },
    },
    methods: {
      isCurrentUser(profile) {
        return profile.userId === this.currentUserId;
      }
    },
  }
</script>

<style scoped>
.profiles-container{
  margin: 0 auto 0 auto;
}
</style>